import { Injectable } from '@angular/core';
import {AuthService} from "./auth.service";
import {Router} from "@angular/router";
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import {catchError, Observable, throwError} from "rxjs";
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthInterceptorService implements HttpInterceptor {
  private redirecting = false;

  constructor(private authService: AuthService,
              private router: Router) {
  }

  private handleAuthError(err: HttpErrorResponse): Observable<any> {
    if ((err.status === 401 || err.status === 403) && this.router.url !== "/auth/login") {
      this.authService.user.set(null);
      sessionStorage.clear();
      AuthService.clearStoredAuth();
      if (!this.redirecting) {
        this.redirecting = true;
        window.location.href = '';
      }
      return throwError(() => err);
    }
    return throwError(() => err);
  }

  private isApiRequest(url: string): boolean {
    if (url.startsWith('http://') || url.startsWith('https://')) {
      return url.startsWith(environment.apiUrl);
    }

    return url.startsWith('/api') || url.startsWith('api/');
  }

  // this method will add the Bearer token to the Header of the HTTP-Request if a user is logged in
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.authService.user()?.token && this.isApiRequest(req.url)) {
      const modifiedRequest = req.clone({ setHeaders: { Authorization: "Bearer " + this.authService.user()?.token } });
      return next.handle(modifiedRequest).pipe(
        catchError((error: HttpErrorResponse) => {
          return this.handleAuthError(error);
        }));
    }

    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        return this.handleAuthError(error);
      }));
  }

}
